import { Pipe, PipeTransform } from "@angular/core";
import {
  DataService,
  GetCountryDetailDocument,
} from "@bb-vendure/admin-ui/core";
import { map } from "rxjs";
import { EventIdolDocument } from "src/generated-gql/graphql";
import { Observable } from "rxjs";

@Pipe({
  name: "country",
  standalone: true,
})
export class CountryPipe implements PipeTransform {
  constructor(protected dataService: DataService) {}
  transform(value: string): Observable<string | undefined> {
    return this.dataService
      .query(GetCountryDetailDocument, { id: value.toString() })
      .single$.pipe(
        map((res) => {
          return res.country?.code;
        })
      );
  }
}
